var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseApi } from '../baseApi';
export default class UsageCostApi extends BaseApi {
    constructor() {
        super(...arguments);
        this.apiBasePath = '/usage-cost';
    }
    collectDeepgramCosts() {
        return __awaiter(this, arguments, void 0, function* (data = {}, apiParams = {}) {
            return yield this.apiCall(Object.assign({ method: 'POST', route: `${this.apiBasePath}/collect/deepgram`, data }, apiParams));
        });
    }
    getUsageCost(filters_1) {
        return __awaiter(this, arguments, void 0, function* (filters, apiParams = {}) {
            return yield this.apiCall(Object.assign({ method: 'GET', route: this.apiBasePath, params: filters }, apiParams));
        });
    }
    getUsageCostCursor(filters_1) {
        return __awaiter(this, arguments, void 0, function* (filters, apiParams = {}) {
            return yield this.apiCall(Object.assign({ method: 'GET', route: `${this.apiBasePath}/cursor`, params: filters }, apiParams));
        });
    }
    getAwsResourcesCursor(filters_1) {
        return __awaiter(this, arguments, void 0, function* (filters, apiParams = {}) {
            return yield this.apiCall(Object.assign({ method: 'GET', route: `${this.apiBasePath}/aws-resources/cursor`, params: filters }, apiParams));
        });
    }
    getAwsResourceFilterOptions() {
        return __awaiter(this, arguments, void 0, function* (apiParams = {}) {
            return yield this.apiCall(Object.assign({ method: 'GET', route: `${this.apiBasePath}/aws-resources/filter-options` }, apiParams));
        });
    }
    getAwsResourceSuggestions(params_1) {
        return __awaiter(this, arguments, void 0, function* (params, apiParams = {}) {
            return yield this.apiCall(Object.assign({ method: 'GET', route: `${this.apiBasePath}/aws-resources/resource-suggestions`, params }, apiParams));
        });
    }
    startAwsResourceCsvExport(filters) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'POST',
                route: `${this.apiBasePath}/aws-resources/csv/export-init`,
                data: filters,
            });
        });
    }
    startCsvExport(filters) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'POST',
                route: `${this.apiBasePath}/csv/export-init`,
                data: filters,
            });
        });
    }
}
//# sourceMappingURL=index.js.map